export default __webpack_public_path__ + "static/media/DNo.25-4.51b336b6.jpg";